/**
 * @class ShowDeletedFilter
 *
 * A simple Yes/No filter for showing deleted items.
 * Uses the same visual pattern as TieredSelect for consistency.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Input, Label, FormGroup } from 'reactstrap';
import BreadcrumbsBack from '../lookups/breadcrumbsBack';
const OPTIONS = [{
  id: 0,
  name: 'No'
}, {
  id: 1,
  name: 'Yes'
}];
const ShowDeletedFilter = _ref => {
  let _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    onChange = _ref.onChange,
    onBack = _ref.onBack,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Show Deleted' : _ref$label;
  const handleSelect = option => {
    onChange(option.id);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, label), /*#__PURE__*/React.createElement(BreadcrumbsBack, {
    onBack: onBack,
    onSelect: onBack,
    backLabel: "Filters"
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "animation-wrapper tiered-entity-select"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: '50vh',
      overflowX: 'scroll'
    }
  }, OPTIONS.map(option => /*#__PURE__*/React.createElement("div", {
    key: "div-".concat(option.id)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormGroup, {
    check: true
  }, /*#__PURE__*/React.createElement(Label, {
    check: true
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    className: "t-sdf-option t-sdf-option-".concat(option.name.toLowerCase()),
    checked: value === option.id,
    onChange: () => handleSelect(option)
  }), ' ', option.name))), /*#__PURE__*/React.createElement("hr", null))))));
};
ShowDeletedFilter.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  label: PropTypes.string
};
export default ShowDeletedFilter;